import type { Components, Theme } from "@mui/material";

export const MuiCard: Components<Theme>["MuiCard"] = {
	defaultProps: {
		variant: "outlined",
	},
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				borderRadius: theme.spacing(3),
			}),
		},
		{
			props: { variant: "subscription" },
			style: ({ theme }) => ({
				background: theme.palette.muted.main,
				borderRadius: theme.spacing(3),
				display: "flex",
				flexDirection: "column",
				gap: theme.spacing(3),
				height: "100%",
				[theme.breakpoints.up("xs")]: {
					padding: theme.spacing(3),
				},
				[theme.breakpoints.up("md")]: {
					padding: theme.spacing(4),
				},
			}),
		},
		{
			props: { variant: "dashboard" },
			style: ({ theme }) => ({
				borderColor: theme.palette.muted.dark,
				borderStyle: "solid",
				borderWidth: 1,
				display: "flex",
				flexDirection: "column",
				gap: theme.spacing(3),
				padding: theme.spacing(3),
			}),
		},
	],
};

export const MuiCardHeader: Components<Theme>["MuiCardHeader"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				".MuiCardHeader-title": {
					fontSize: theme.typography.pxToRem(18),
					fontWeight: 500,
				},
			}),
		},
	],
};

export const MuiCardContent: Components<Theme>["MuiCardContent"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				padding: theme.spacing(2),
				"&:last-child": {
					padding: theme.spacing(2),
				},
			}),
		},
	],
};
